import React from 'react'

import IconLoading from '@/assets/lottie/loading.json'

import clsx from 'clsx'
import Lottie from 'lottie-react'

interface LoadingComponentProps {
  className?: string
}

export const LoadingComponent: React.FC<LoadingComponentProps> = ({ className }) => {
  return (
    <div
      className={clsx('fixed left-0 top-0 flex h-screen w-full items-center justify-center bg-black-100', className)}
      style={{ zIndex: 9999 }}
    >
      <div>
        <Lottie animationData={IconLoading} className='mx-auto size-14' loop={true} />
      </div>
    </div>
  )
}
